import { render, staticRenderFns } from "./ProductSharing.vue?vue&type=template&id=027abd09&scoped=true"
import script from "./ProductSharing.vue?vue&type=script&lang=js"
export * from "./ProductSharing.vue?vue&type=script&lang=js"
import style0 from "./ProductSharing.vue?vue&type=style&index=0&id=027abd09&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027abd09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027abd09')) {
      api.createRecord('027abd09', component.options)
    } else {
      api.reload('027abd09', component.options)
    }
    module.hot.accept("./ProductSharing.vue?vue&type=template&id=027abd09&scoped=true", function () {
      api.rerender('027abd09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/ProductSharing.vue"
export default component.exports